<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div style="margin-bottom: 5px">
        <el-button @click="excelPost">押金变动明细表</el-button>
        <el-button @click="excelPostIncom">押金收入明细表</el-button>
        <el-button @click="excelPostRefund">押金退款明细表</el-button>
      </div>
      <div class="cdj_div">客户押金变动明细表-查询条件</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">房产范围</div>
              <el-select
                v-model="data.houseName"
                class="cdj_el-input"
                size="mini"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="可搜索房产/客户姓名"
                :remote-method="remoteMethod"
                :loading="loading"
              >
                <el-option
                  v-for="item in selectList"
                  :key="item.id"
                  :label="item.house"
                  :value="item.house"
                >
                </el-option>
              </el-select>
            </div>

            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">发生日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="startDate"
                  type="date"
                  placeholder="开始时间"
                  value-format="timestamp"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="endDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="timestamp"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">客户</div>
              <div class="cdj_el-input">
                <el-input
                  class="cdj_el-input"
                  style="width: 70%"
                  v-model="data.customer"
                  type="text"
                  :clearable="true"
                  size="mini"
                ></el-input>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemID"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 50%"
                  placeholder="收费项目"
                >
                  <el-option
                    size="mini"
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel"
                  >取消</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 1px; margin-top: 10px">
        <el-button size="mini" type="primary text2" @click="searchs()"
          >搜索</el-button
        >
        <!-- <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="excelPost"
          >导出</el-button
        > -->
      </div>
      <!-- <div style="display: flex; color: red; margin-top: 7px">
        <div>总金额：￥{{ money }}元</div>
      </div> -->
      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">客户名称</th>
              <th class="text-left">房产</th>
              <th class="text-left">押金类型</th>
              <th class="text-left">财务科目</th>
              <th class="text-left">结算方式</th>
              <th class="text-left">前余额</th>
              <th class="text-left">发生额</th>
              <th class="text-left">后余额</th>
              <th class="text-left">票据号码</th>
              <th class="text-left">备注</th>
              <th class="text-left">发生时间</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <tr class="text1" v-for="item in desserts" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.house }}</td>
              <td>{{ item.deposit_type }}</td>
              <td>{{ item.mark }}</td>
              <td>{{ item.payment_name }}</td>
              <td>{{ item.balance }}</td>
              <td>
                <template v-if="item.mark === '押金收入'">{{
                  item.money
                }}</template
                ><template v-else>-{{ item.money }}</template>
              </td>
              <td>{{ item.afterBalance }}</td>
              <td>{{ item.bill_number }}</td>
              <td>{{ item.beizhus }}</td>
              <td>{{ item.date }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change" show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
  </div>
</template>

<script>
import imgurl from "@/assets/js/imgurl.js";
export default {
  name: "DepositUpdate",
  data() {
    return {
      pid: "",
      startDate: "",
      endDate: "",
      chargeitem: [],
      money: "--",
      loading: false,
      desserts: "",
      total: 0,
      page: 12,
      selectList: [],
      data: {
        startDate: "",
        endDate: "",
        customer: "",
        chargeitemID: [],
        pid: "",
        houseName: "",
        house_id: "",
      },
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    // this.change(1);
    // this.moneys();
    //押金类型
    this.$myhttp
      .get("admin/common/deposit_type", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    //导出
    excelPost() {
      this.dates();
      let _this = this;
      ERP.showLoading();
      this.$myhttp
        .post("admin/DepositDetail/changeDetailExcel", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          let url = imgurl + backdata.data.data;
          window.open("/office.html#/office?url=" + url, "_blank");
        })
        .catch(function (error) {
          _this.$Message.error("数据太多了，分批导出");
          ERP.hideLoading();
        });
    },
    excelPostIncom() {
      this.dates();
      let _this = this;
      ERP.showLoading();
      this.$myhttp
        .post("admin/DepositDetail/changeDetailIncomeExcel", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          let url = imgurl + backdata.data.data;
          window.open(url, "_blank");
        })
        .catch(function (error) {
          _this.$Message.error("数据太多了，分批导出");
          ERP.hideLoading();
        });
    },
    excelPostRefund() {
      this.dates();
      let _this = this;
      ERP.showLoading();
      this.$myhttp
        .post("admin/DepositDetail/changeDetailRefundExcel", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          let url = imgurl + backdata.data.data;
          window.open(url, "_blank");
        })
        .catch(function (error) {
          _this.$Message.error("数据太多了，分批导出");
          ERP.hideLoading();
        });
    },
    //查询总押金
    moneys() {},
    //获得当前多少页,分页
    change(e) {
      this.dates();
      ERP.showLoading();
      this.$Loading.start();
      this.data.page = e;
      this.$myhttp
        .post("admin/DepositDetail/index", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          this.$Loading.finish();
          ERP.hideLoading();
        });
    },
    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      console.log(data.tree);
      this.data.pid = data.tree[0]["id"];
      this.data.houseName = tree_str;
      this.data.house_id = "";
      if (data.tree[data.tree.length - 1].type === "room") {
        this.data.house_id = data.tree[data.tree.length - 1].id;
        this.change(1);
      }
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.data.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.data.chargeitemID = [];
    },
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    // 时间转换
    dates() {
      this.data.startDate = "";
      this.data.endDate = "";
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = d / 1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate; //结束时间
        let endDate = d / 1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
    },
  },

  watch: {},

  components: {
    "erp-tree": () => import("../Common/erp-tree.vue"),
  },
};
</script>
<style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/depositUpdate.vue